import { render, staticRenderFns } from "./Reinversion.vue?vue&type=template&id=6ed23b47&"
import script from "./Reinversion.vue?vue&type=script&lang=js&"
export * from "./Reinversion.vue?vue&type=script&lang=js&"
import style0 from "./Reinversion.vue?vue&type=style&index=0&id=6ed23b47&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports